<div class="sidenav-panel-container" [class.variant-specializations]="variant() === 'specializations'">
  <!-- Back button -->
  <div class="back-button-container">
    <button class="back-button" (click)="onBackClick()" aria-label="Go back to main menu">
      <fa-icon [icon]="faArrowLeft"></fa-icon>
    </button>
  </div>

  <!-- Title and description -->
  <div class="header-section">
    <div class="title">{{ t('title') | translate }}</div>
    <div class="description">{{ t('description') | translate }}</div>
    <div class="hint">
      {{ t('hint1') | translate }}
      <div class="hint-bold">{{ t('searchBar') | translate }}</div>
      {{ t('hint2') | translate }}
      <div class="hint-bold">{{ t('showAll') | translate }}</div>.
    </div>
  </div>

  <!-- Search input -->
  <div class="search-container">
    <input
      type="text"
      class="search-input"
      [attr.aria-label]="t('searchAriaLabel') | translate"
      [placeholder]="t('searchPlaceholder') | translate"
      [ngModel]="searchValue()"
      (ngModelChange)="searchValue.set($event)"
      (keydown)="onSearchKeydown($event)"
    />
    <button
      class="search-button"
      [attr.aria-label]="t('searchButtonAriaLabel') | translate"
      (click)="onSearchSubmit()"
    >
      <fa-icon [icon]="faMagnifyingGlass"></fa-icon>
    </button>
  </div>

  <!-- Item chips -->
  <div class="items-grid" [class.expanded]="showAllItems()">
    @for (item of filteredItems(); track item.id) {
      <button
        class="item-chip"
        [attr.aria-label]="item.label"
        (click)="onItemClick(item)"
      >
        <div class="chip-label">{{ item.label }}</div>
        <fa-icon [icon]="faChevronRight" class="chip-icon" aria-hidden="true"></fa-icon>
      </button>
    } @empty {
      <div class="empty-state">
        <div class="empty-state-text">{{ t('noResults') | translate }}</div>
      </div>
    }
  </div>

  <!-- Show all button -->
  <div class="show-all-container">
    <button
      class="show-all-button"
      [attr.aria-label]="(showAllItems() ? t('showLessButton') : t('showAllButton')) | translate"
      [attr.aria-expanded]="showAllItems()"
      (click)="onShowAllClick()"
    >
      {{ (showAllItems() ? t('showLessButton') : t('showAllButton')) | translate }}
    </button>
  </div>
</div>
